export const getAuditActionNotificationStorageKey = (userId: string) =>
  `audit-action-notification-settings:${userId}`;
